interface ChunkRecoveryOptions {
  target: Window;
  document: Document;
  reload: () => void;
}

/** A deployment/network failure must never silently reload a mounted editor. */
export function installChunkRecovery({
  target,
  document,
  reload,
}: ChunkRecoveryOptions) {
  const onFailure = (event: Event) => {
    event.preventDefault();
    if (document.getElementById("care-chunk-recovery")) return;
    const notice = document.createElement("aside");
    notice.id = "care-chunk-recovery";
    notice.setAttribute("role", "alert");
    notice.style.cssText =
      "position:fixed;bottom:16px;left:16px;right:16px;z-index:99999;padding:16px;background:#fff7ed;color:#7c2d12;border:2px solid #c2410c;border-radius:8px;font:16px sans-serif";
    const message = document.createElement("p");
    message.textContent =
      "Een onderdeel kon niet worden geladen. Controleer uw verbinding. Bewaar eerst uw open werk voordat u de pagina opnieuw laadt.";
    const retry = document.createElement("button");
    retry.type = "button";
    retry.textContent = "Pagina opnieuw laden";
    retry.style.cssText =
      "padding:8px;border:1px solid currentColor;border-radius:4px;margin-right:12px";
    retry.addEventListener("click", () => {
      if (
        target.confirm(
          "Opnieuw laden kan niet-opgeslagen tekst wissen. Heeft u uw werk bewaard en wilt u opnieuw laden?",
        )
      )
        reload();
    });
    const dismiss = document.createElement("button");
    dismiss.type = "button";
    dismiss.textContent = "Verder werken";
    dismiss.addEventListener("click", () => notice.remove());
    notice.append(message, retry, dismiss);
    document.body.append(notice);
  };
  target.addEventListener("vite:preloadError", onFailure);
  return () => target.removeEventListener("vite:preloadError", onFailure);
}
